export const sizeLabels = ['Tiny', 'Small', 'Medium', 'Large', 'Huge'];
